import { render } from "./BreadCrumb.vue?vue&type=template&id=5da85a71&scoped=true&ts=true"
import script from "./BreadCrumb.vue?vue&type=script&lang=ts"
export * from "./BreadCrumb.vue?vue&type=script&lang=ts"

import "./BreadCrumb.vue?vue&type=style&index=0&id=5da85a71&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da85a71"]])

export default __exports__